import { render, staticRenderFns } from "./SetupModulePopup.vue?vue&type=template&id=5712ffc0&scoped=true"
import script from "./SetupModulePopup.vue?vue&type=script&lang=js"
export * from "./SetupModulePopup.vue?vue&type=script&lang=js"
import style0 from "./SetupModulePopup.vue?vue&type=style&index=0&id=5712ffc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712ffc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5712ffc0')) {
      api.createRecord('5712ffc0', component.options)
    } else {
      api.reload('5712ffc0', component.options)
    }
    module.hot.accept("./SetupModulePopup.vue?vue&type=template&id=5712ffc0&scoped=true", function () {
      api.rerender('5712ffc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/SetupModulePopup.vue"
export default component.exports